import { Injectable, NgZone } from '@angular/core';
import posthog from 'posthog-js';
import { HttpErrorResponse } from '@angular/common/http';
import { isNullish } from '@examdojo/core/util/nullish';
import { extractHttpError, isErrorOrErrorLikeObject } from './posthog-error-handling.util';

@Injectable({
  providedIn: 'root',
})
export class PosthogErrorHandlingService {
  constructor(private readonly ngZone: NgZone) {}

  identifyUser(userId: string, traits?: Record<string, unknown>): void {
    posthog.identify(userId, traits);
  }

  setUserTraits(traits: Record<string, unknown>): void {
    posthog.capture('$set', {
      $set: traits,
    });
  }

  resetUser(): void {
    posthog.reset();
  }

  track(event: unknown, context?: Record<string, unknown>): void {
    const extractedError = this.extractError(event);
    if (isNullish(extractedError)) {
      return;
    }

    this.ngZone.runOutsideAngular(() => posthog.captureException(extractedError, context));
  }

  protected extractError(error: unknown) {
    if (error instanceof HttpErrorResponse) {
      return extractHttpError(error);
    }

    if (typeof error === 'string' || isErrorOrErrorLikeObject(error)) {
      return error;
    }

    return null;
  }
}
